import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { isEmpty } from '@witmetrics/utils/misc';
import type { ColorConfig } from '@witmetrics/unison-core';
import Card from '@/components/Card';
import { classes } from './utils';

export { default as FileControls } from './FileControls';
export { default as FileCollectionControls } from './FileCollectionControls';

export type ViewerHeaderProps = {
  title: string;
  description?: string;
  colors?: ColorConfig;
  icon: ReactNode;
  controls: ReactNode;
};

export default function ViewerHeader({
  title,
  description,
  colors,
  icon,
  controls,
}: ViewerHeaderProps) {
  return (
    <Card
      className={twMerge(
        classes.card,
        colors?.gradient?.to,
        colors?.gradient?.from
      )}>
      <div className={classes.contentWrapper}>
        {icon}
        <div className={classes.titleWrapper}>
          <h1 className={classes.name}>{title}</h1>
          {!isEmpty(description) && (
            <p className={classes.description}>{description}</p>
          )}
        </div>
      </div>
      {controls}
    </Card>
  );
}
